import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { User } from "../App";
import { useCookies } from "react-cookie";

const PrivateRoutes = () => {
    const [isAuthenticated, setisAuthenticated]: any = useAtom(User);
    const [cookies, setCookie,removeCookie] = useCookies(["UserGad"]);
  return cookies && cookies.UserGad.length ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoutes;
